<template>
	<div class="fondoModal" v-if="contacto !== null">
		<div>
			<div>
				<div class="card">
					<div class="card-header">
						Editor de contactos
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body pt-0 pb-0">
						<div class="row mt-0 mb-0">
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 text-center pt-2 pb-4">
								<img :src="avatar" alt="avatar" class="rounded-circle" style="width:150px;height:150px;">
								<div class="text-center mt-2 mb-2">
									<button class="btn btn-sm btn-primary">
										<span class="fa fa-photo mr-2"></span>
										Subir foto
									</button>
								</div>
								<div class="input-group mt-2">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-w fa-edit"></span>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="Nombre" v-model="contacto.nombre">
								</div>
								<div class="input-group mt-2">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-w fa-edit"></span>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="Apellidos" v-model="contacto.apellidos">
								</div>
								<div class="btn-group mt-2">
									<button class="btn" :class="(contacto.genero === 'hombre') ? 'btn-primary' : ''" @click="contacto.genero = 'hombre'">
										<span class="fa fa-male mr-2"></span>
										Hombre
									</button>
									<button class="btn" :class="(contacto.genero === 'mujer') ? 'btn-primary' : ''" @click="contacto.genero = 'mujer'">
										<span class="fa fa-female mr-2"></span>
										Mujer
									</button>
								</div>
								<div class="form-group mt-2 text-left">
									<label for=""><b>Fecha de nacimiento</b></label>
									<datepicker
										:monday-first="true"
										:language='$dateLang'
										input-class="form-control"
										v-model="contacto.nacimiento"
									></datepicker>
								</div>
								<hr>
								<div class="text-left">
									<b>Libreta(s):</b>
									<select name="" id="" class="form-control" @change="seleccionaLibreta($event)">
										<option value="null">Selecciona la(s) libreta(s)</option>
										<option :value="libreta.ID_libreta" v-for="libreta in listadoLibretas" :key="libreta.ID_libreta">{{libreta.nombre}}</option>
									</select>
									<div class="mt-2">
										<button class="btn btn-primary btn-sm m-2" @click="quitaLibreta(libreta.ID_libreta)" v-for="libreta in contacto.libretas" :key="libreta.ID_libreta">
											<span class="fa fa-trash mr-2"></span>
											{{libreta.nombre}}
										</button>
									</div>
								</div>
							</div>
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left bg-light pt-2 pb-2">
								<div class="card mb-3">
									<div class="card-header">
										<span class="fa fa-building mr-2"></span>
										<b>Organizaciónes</b>
									</div>
									<div class="card-body">
										<div class="row mt-2" v-for="(org, index) in contacto.organizaciones" :key="index+'_'+org.ID_organizacion">
											<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2">
												<div class="input-group">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<span class="fa fa-w fa-building"></span>
														</span>
													</div>
													<input-query v-if="org.ID_organizacion === null" input-class="form-control m-0" class="form-control" url="libreta-direcciones/php/buscaOrganizaciones.php" :realtime="true" @selected="setOrganizacion(index, $event)"></input-query>
													<input type="text" class="form-control" :value="org.nombre" disabled="true" v-if="org.ID_organizacion !== null">
													<div class="input-group-append" v-if="org.ID_organizacion">
														<button class="btn btn-danger" @click="org.ID_organizacion = null">
															<span class="fa fa-trash"></span>
														</button>
													</div>
												</div>
											</div>
											<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2">
												<div class="input-group">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<span class="fa fa-w fa-suitcase"></span>
														</span>
													</div>
													<input type="text" class="form-control" placeholder="Cargo" v-model="org.cargo">
													<div class="input-group-append">
														<button class="btn btn-danger" @click="contacto.organizaciones.splice(index, 1)">
															<span class="fa fa-trash"></span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-primary" @click="nuevaOrganizacion()">
											<span class="fa fa-building mr-2"></span>
											Añadir organización
										</button>
									</div>
								</div>

								<div class="card mb-3">
									<div class="card-header">
										<span class="fa fa-phone mr-2"></span>
										<b>Teléfonos</b>
									</div>
									<div class="card-body">
										<div class="input-group mt-2" v-for="telefono in contacto.telefonos" :key="telefono.ID_telefono">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<span class="fa fa-w fa-phone"></span>
												</span>
											</div>
											<input type="text" class="form-control" placeholder="XXX XXX XXX" v-model="telefono.telefono">
											<div class="input-group-append" @click="quitaTelefono(telefono)">
												<button class="btn btn-danger">
													<span class="fa fa-w fa-trash"></span>
												</button>
											</div>
										</div>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-primary" @click="nuevoTelefono()">
											<span class="fa fa-w fa-phone mr-2"></span>
											Añadir teléfono
										</button>
									</div>
								</div>


								<div class="card mb-3">
									<div class="card-header">
										<span class="fa fa-phone mr-2"></span>
										<b>E-mails</b>
									</div>
									<div class="card-body">
										<div class="input-group mt-2" v-for="email in contacto.emails" :key="email.ID_email">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<span class="fa fa-w fa-envelope"></span>
												</span>
											</div>
											<input type="text" class="form-control" placeholder="alguien@algo" v-model="email.email">
											<div class="input-group-append" @click="quitaEmail(email)">
												<button class="btn btn-danger">
													<span class="fa fa-w fa-trash"></span>
												</button>
											</div>
										</div>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-primary" @click="nuevoEmail()">
											<span class="fa fa-w fa-envelope mr-2"></span>
											Añadir email
										</button>
									</div>
								</div>


								<div class="card mb-3">
									<div class="card-header">
										<span class="fa fa-map mr-2"></span>
										<b>Direcciones</b>
									</div>
									<div class="card-body" :class="(index % 2 === 0) ? 'bg-light' : ''" v-for="(direccion, index) in contacto.direcciones" :key="direccion.ID_direccion">
										<div class="row">
											<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
												<div class="form-group">
													<label for="">País</label>
													<input type="text" class="form-control form-control-sm" placeholder="País" v-model="direccion.pais">
												</div>
											</div>
											<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
												<div class="form-group">
													<label for="">Comunidad</label>
													<input type="text" class="form-control form-control-sm" placeholder="Comunidad" v-model="direccion.comunidad">
												</div>
											</div>
											<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
												<div class="form-group">
													<label for="">Localidad</label>
													<input type="text" class="form-control form-control-sm" placeholder="Localidad"  v-model="direccion.localidad">
												</div>
											</div>
										</div>
										<div class="input-group input-group-sm mt-2 mb-2">
											<div class="input-group-prepend">
												<span class="input-group-text">
													Vía
												</span>
											</div>
											<input type="text" class="form-control" placeholder="Nombre de la calle" v-model="direccion.calle">
										</div>
										<div class="row">
											<div class="mb-2 col-xs-12 col-sm-6 col-md-5 col-lg-3 col-xl-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															C.P.
														</span>
													</div>
													<input type="text" class="form-control form-control-sm" v-model="direccion.cp">
												</div>
											</div>
											<div class="mb-2 col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Nº
														</span>
													</div>
													<input type="text" class="form-control form-control-sm" v-model="direccion.numero">
												</div>
											</div>
											<div class="mb-2 col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-2">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Esc
														</span>
													</div>
													<input type="text" class="form-control form-control-sm" v-model="direccion.portal">
												</div>
											</div>
											<div class="mb-2 col-xs-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Piso
														</span>
													</div>
													<input type="text" class="form-control form-control-sm" v-model="direccion.piso">
												</div>
											</div>
											<div class="mb-2 col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Puerta
														</span>
													</div>
													<input type="text" class="form-control form-control-sm" v-model="direccion.puerta">
												</div>
											</div>
										</div>
										<div class="form-group">
											<label for="">Comentarios</label>
											<textarea name="comentarios" id="" class="form-control" rows="5" v-model="direccion.comentarios"></textarea>
										</div>
										<button class="btn btn-danger btn-sm" @click="quitarDireccion(direccion)">
											<span class="fa fa-trash mr-2"></span>
											Quitar
										</button>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-primary" @click="nuevaDireccion()">
											<span class="fa fa-w fa-map mr-2"></span>
											Añadir dirección
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<div class="row">
							<div class="col text-left">
								<button class="btn btn-sm btn-primary" @click="guardar()">
									<span class="fa fa-w fa-save mr-2"></span>
									Guardar
								</button>

								<button class="btn btn-sm btn-danger" @click="eliminar()" v-if="contacto.ID_registro">
									<span class="fa fa-w fa-trash mr-2"></span>
									Eliminar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from '../service'
export default {

	props: ['datos'],
	data () {
		return {
			contacto: null,
			listadoLibretas: []
		}
	},
	created () {
		console.log(this.datos)
		if (this.datos === 'nuevo') {
			this.nuevoContacto()
		} else {
			this.getContacto()
		}

		API.getLibretas(true)
			.then(res => {
				this.listadoLibretas = res.data.libretas
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	computed: {
		avatar () {
			if (this.contacto.avatar) {
				return this.contacto.avatar
			}

			if (this.contacto.genero === 'mujer') {
				return '/static/recursos/mujer.svg'
			} else {
				return '/static/recursos/hombre.svg'
			}
		}
	},
	methods: {
		nuevoContacto () {
			this.contacto = {
				ID_registro: null,
				nombre: '',
				apellidos: '',
				genero: 'hombre',
				nacimiento: null,
				avatar: null,
				organizaciones: [],
				telefonos: [],
				emails: [],
				direcciones: [],
				libretas: []
			}
		},
		getContacto () {
			API.getRegistro(this.datos)
				.then(res => {
					this.contacto = res.data.registro
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		seleccionaLibreta (ev) {
			const id = parseInt(ev.srcElement.value)
			if (id === 'null') {
				return
			}

			for (let i = 0; i < this.contacto.libretas.length; i++) {
				if (this.contacto.libretas[i].ID_libreta === id) {
					ev.srcElement.value = 'null'
					return
				}
			}

			for (let i = 0; i < this.listadoLibretas.length; i++) {
				if (parseInt(this.listadoLibretas[i].ID_libreta) === parseInt(ev.srcElement.value)) {
					this.contacto.libretas.push(this.listadoLibretas[i])
				}
			}
			ev.srcElement.value = 'null'
		},

		quitaLibreta (idLibreta) {
			for (let i = 0; i < this.contacto.libretas.length; i++) {
				if (this.contacto.libretas[i].ID_libreta === idLibreta) {
					this.contacto.libretas.splice(i, 1)
					return
				}
			}
		},

		nuevaOrganizacion () {
			this.contacto.organizaciones.push({
				ID_organizacion: null,
				nombreOrganizacion: '',
				cargo: ''
			})
		},
		nuevoTelefono () {
			const id = 'nuevo_telefono_' + (this.contacto.telefonos.length + 1).toString()
			this.contacto.telefonos.push({
				ID_telefono: id,
				telefono: ''
			})
		},
		quitaTelefono (telefono) {
			for (let i = 0; i < this.contacto.telefonos.length; i++) {
				if (this.contacto.telefonos[i].ID_telefono === telefono.ID_telefono) {
					this.contacto.telefonos.splice(i, 1)
				}
			}
		},
		nuevoEmail () {
			const id = 'nuevo_email_' + (this.contacto.emails.length + 1).toString()
			this.contacto.emails.push({
				ID_email: id,
				email: ''
			})
		},
		quitaEmail (email) {
			for (let i = 0; i < this.contacto.emails.length; i++) {
				if (this.contacto.emails[i].ID_email === email.ID_email) {
					this.contacto.emails.splice(i, 1)
					return
				}
			}
		},
		nuevaDireccion () {
			const id = 'nueva_direccion_' + (this.contacto.direcciones.length + 1).toString()
			this.contacto.direcciones.push({
				ID_direccion: id,
				pais: '',
				comunidad: '',
				provincia: '',
				localidad: '',
				via: '',
				numero: '',
				esc: '',
				piso: '',
				puerta: '',
				cp: '',
				comentarios: ''
			})
		},
		quitarDireccion (direccion) {
			for (let i = 0; i < this.contacto.direcciones.length; i++) {
				if (this.contacto.direcciones[i].ID_direccion === direccion.ID_direccion) {
					this.contacto.direcciones.splice(i, 1)
				}
			}
		},

		setOrganizacion (i, ev) {
			if (ev.datos.ID_organizacion === 'nueva') {
				this.$store.commit('alertas/confirm', {
					titulo: 'Crear nueva organización',
					mensaje: `¿Quieres crear la organización: "${ev.datos.nombre}"?`,
					callback: (acepta) => {
						if (!acepta) {
							return false
						}

						this.contacto.organizaciones[i].ID_organizacion = 'nueva'
						this.contacto.organizaciones[i].nombre = ev.datos.nombre
					}
				})
			} else {
				this.contacto.organizaciones[i].ID_organizacion = ev.datos.ID_organizacion
				this.contacto.organizaciones[i].nombre = ev.datos.nombre
			}
		},

		guardar () {
			if (this.contacto.nombre === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir el nombre del contacto'
				})
				return
			}

			if (this.contacto.apellidos === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir los apellidos del contacto'
				})
				return
			}

			if (this.contacto.libretas.length === 0) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes seleccionar al menos una libreta para almacenar el contacto'
				})
				return
			}

			API.setRegistro(this.contacto)
				.then(res => {
					this.contacto = res.data.registro
					this.$store.commit('toast/success', {
						titulo: 'Contacto guardado',
						mensaje: 'Se ha guardado el contacto correctamente'
					})
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			this.$emit('cerrar')
		},

		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contacto',
				mensaje: `¿Estás seguro de que quieres eliminar este contacto?
				Se borrará también de todas las libretas en las que esté incluído`,
				callback: (acepta) => {
					if (acepta) {
						API.eliminar(this.contacto.ID_registro)
							.then(res => {
								this.cerrar()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/libreta-direcciones/vue/contactos/editor-contacto.vue